<template>
    <div>
        <b-button-group>
            <b-button
                variant="primary"
                @click.stop="exportar(0)"
                title="Exportar em PDF"
                :disabled="desabilitar"
            >
                <i class="fa fa-file-pdf-o"></i>
            </b-button>
            <b-button
                variant="primary"
                @click.stop="exportar(1)"
                title="Exportar em Excel"
                :disabled="desabilitar"
            >
                <i class="fa fa-file-excel-o"></i>
            </b-button>
        </b-button-group>
    </div>
</template>

<script>
import download from './../../../shared/download'
import PagamentosServicos from './PagamentosServicos'

export default {
	props: {
		desabilitar: {
			type: Boolean,
			default: () => false
		},
		dataInicial: {
			type: String,
			default: () => ''
		},
		dataFinal: {
			type: String,
			default: () => ''
		},
		status: {
			type: Number,
			default: () => 0
		},
		fornecedorId: {
			type: String,
			default: () => null
		},

		dataServico: {
			type: Object,
			default: () => {}
		}
	},

	data() {
		return {}
	},

	methods: {
		exportar(tipo) {
			this.$store.dispatch('addRequest')
			let exportarPagamentosDto = {
				dataInicial: this.dataInicial,
				dataFinal: this.dataFinal,
				status: this.status,
				tipo: tipo
			}
			let promisse
			if (this.fornecedorId) {
				promisse = this.dataServico.exportarPagamentos(
					this.fornecedorId,
					exportarPagamentosDto
				)
			} else {
				promisse = PagamentosServicos.exportarPagamentos(
					exportarPagamentosDto
				)
			}
			promisse.then(response => {
				if (response) {
					if (response.type === 'application/json') {
						this.$toast.error(
							'Falha ao Exportar Pagamentos',
							'ERROR',
							this.$toastConfig.error
						)
					} else {
						download(
							response,
							`Relacao_de_Pagamentos.${
								tipo == 0 ? 'pdf' : 'xlsx'
							}`
						)
					}
				}
				this.$store.dispatch('removeRequest')
			})
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
